import { Button } from "@radix-ui/themes";
import { Link as NavLink } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ErrorPage } from "../../../components/ErrorPage";
import { canAccessPunttDashboard, canUploadTickets } from "../../../utils/auth";
import { indexRoute } from "../../index/route";

type EmptyTicketsViewProps = {
  onFilesUpload(): void;
};

export function EmptyTicketsView(props: EmptyTicketsViewProps) {
  const { t } = useTranslation("ui");
  const { onFilesUpload } = props;

  return (
    <ErrorPage
      title={t("tickets.emptyTicketsView.nothingSeeHereYet")}
      description={
        canAccessPunttDashboard() ? (
          <>
            Visit{" "}
            <NavLink
              className="puntt-link"
              to={indexRoute.to}
              data-testid="empty-tickets-home-link"
            >
              {t("tickets.emptyTicketsView.home")}
            </NavLink>{" "}
            to start a new document.
          </>
        ) : (
          "Drop files and folders here to start"
        )
      }
      variant="empty"
    >
      {!canAccessPunttDashboard() && canUploadTickets() && (
        <Button
          size="2"
          variant="outline"
          mx="auto"
          color="gray"
          className="max-w-max"
          onClick={onFilesUpload}
          data-auth-trigger="upload-files"
          data-testid="empty-tickets-upload-button"
        >
          {t("tickets.emptyTicketsView.uploadFileS")}
        </Button>
      )}
    </ErrorPage>
  );
}
